import { render, staticRenderFns } from "./PaginaAdminInformadoresMunicipales.vue?vue&type=template&id=19fac491&lang=es"
import script from "./PaginaAdminInformadoresMunicipales.vue?vue&type=script&lang=js"
export * from "./PaginaAdminInformadoresMunicipales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports